export default __webpack_public_path__ + "static/media/snowuns-mobile-text.84abf1ee.png";